import { EmptyStateIcon } from '@systemeio/icons'
import { ComponentPropsWithoutRef, ComponentType, PropsWithChildren } from 'react'
import { SafeHtmlText } from 'shared/components/safe-html-text'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'

export interface EmptyStateProps extends PropsWithChildren {
  icon?: ComponentType<ComponentPropsWithoutRef<'svg'>>
  title?: string
  description?: string
  className?: string
}

export const EmptyState = ({
  icon: Icon = EmptyStateIcon,
  title,
  description,
  className,
  children,
}: EmptyStateProps) => {
  return (
    <div
      className={twMerge(
        'mx-auto my-auto flex w-full flex-col items-center justify-center gap-4 px-4 py-20 text-center text-base',
        className,
      )}
    >
      <Icon className="size-30 shrink-0" />
      <div className="flex flex-col items-center gap-2">
        {title && <SafeHtmlText html={title} />}
        {description && <SafeHtmlText className="text-text-secondary" html={description} />}
      </div>
      {children}
    </div>
  )
}

export const EmptyListState = (props: EmptyStateProps) => {
  const { t } = useLocoTranslation()
  return (
    <EmptyState
      title={t('dashboard.list.empty_title')}
      description={t('dashboard.list.empty_list')}
      {...props}
    />
  )
}
